const tickFormatter = (date: string): string => {
  const translateMonth: { [key: string]: string } = {
    Jan: 'Ene',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Abr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Ago',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dic',
  };

  const firstThreeLettersEnglish = date.slice(0, 3);
  const firstThreeLettersSpanish = translateMonth[firstThreeLettersEnglish];
  // extract year from description in the response
  const year = date.slice(-4);
  return `${firstThreeLettersSpanish} ${year}`;
};

export default tickFormatter;
